// #1001 banner: pure decisions for MediaTripBanner. The backend decides "tripped" (same evidence as the media breaker),
// so the banner disappears on the first confirmed send without any client-side bookkeeping.

/** How often the banner re-reads the trip state. */
export const MEDIA_TRIP_POLL_MS = 60_000;

export type MediaReloadOutcome = 'idle' | 'sending' | 'sent' | 'failed';

/** Show only while the backend says tripped, and never while a dunning banner owns the slot. */
export function shouldShowMediaTripBanner(tripped: boolean, dunningVisible: boolean): boolean {
  return tripped && !dunningVisible;
}

/** Map the backend reload reply to the banner state. `reloaded` and `deferred` both mean the request was accepted. */
export function reloadOutcomeFrom(reply: { ok: boolean; outcome?: string } | undefined): MediaReloadOutcome {
  if (reply === undefined || !reply.ok) return 'failed';
  return reply.outcome === 'reloaded' || reply.outcome === 'deferred' ? 'sent' : 'failed';
}
